import React from 'react'
import { Link } from 'react-router-dom'

const Dropdown = ({isOpen,toggle}) => {
    return (
        <div className={ isOpen ? "container px-10  grid grid-rows-4 text-start items-start" : "hidden"}
        onClick={toggle}
        >
        <Link  className=" py-4"  to="/education">Education</Link>
            <Link className=" py-4"  to="/about">About</Link>
            
          <Link className=" py-4"  to="/projects">Projects</Link>
          {/* <Link className=" py-4"  to="/works">Works</Link> */}
          
          <Link  className=" py-4" to="/contacts">Contact</Link>
        </div>
    )
}

export default Dropdown
